const updateFeatureFlags = {
  toastr: 'updated tenant',
  toastr1: ' has been updated successfully',
  toastrError: 'Index not found'
};

export default updateFeatureFlags;
